import { render, staticRenderFns } from "./heart.vue?vue&type=template&id=23b788b0"
import script from "./heart.vue?vue&type=script&lang=js"
export * from "./heart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports